import { Box, Typography } from '@mui/material';
import React, {useState} from 'react';
import { StyledCompanyContainer, StyledFlexStart, StyledSubHeader } from '../../../Components/Styled';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import SelectBoxWithLabel from '../../../Components/SelectBoxWithLable';
import BiztantuFooterButton from '../../../Components/FotterButton';
import BiztantuLoader from '../../../Components/Loader';
import { DataGrid, GridRowModes, GridToolbarContainer, GridToolbar, GridActionsCellItem } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import { handleValidateCodevalue } from '../../../Utility/constant';
import { useSelector } from 'react-redux';

const CreateEditFunction = ({selectionData, handleSavePermission, handleCustomBackbutton}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [userDetail, setUserdetails] = useState(null);
    const [requiredValue, setRequiredvalue] = useState({
        permissionName: false,
        description: false
    });
    

    const handleChangeCompanyDetails = (event) => {
        setUserdetails({
            ...userDetail,
            [event.target.name]: event.target.value
        })
    }

    const handleSave = () => {
        if(userDetail?.permissionName && userDetail?.description) {
            handleSavePermission(userDetail)
        } else {
            setRequiredvalue({
                permissionName: true,
                description: true
            })
        }
    }

    
    return (
        <BiztantuLoader isChildren={true} open={false}>
            <Box sx={{marginBottom: 0, padding: "20px", marginTop: "20px",
                height: "calc(100vh - 131px)",
                overflow: "auto",
                borderRadius: "10px",
                '& .MuiTextField-root': { m: 1, marginTop: 3 },
                }}>
                {/* <Typography variant='h6'>
                    {handleValidateCodevalue(internationalise,'CONF_PERM_EDIT_TITLE_CREATE')}
                </Typography> */}
           
                <StyledFlexStart>
                    <TextFiledWithLabel
                        required={true}
                        name= "permissionName" 
                        sx={{width: "30%"}}
                        error={userDetail?.permissionName ? false : requiredValue?.permissionName}
                        value= {userDetail?.permissionName}
                        label={handleValidateCodevalue(internationalise,'CONF_PERM_EDIT_NAME')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    <TextFiledWithLabel
                        required={true}
                        sx={{width: "70%"}}
                        name= "description"
                        error={userDetail?.description ? false : requiredValue?.description}
                        value= {userDetail?.description}
                        label={handleValidateCodevalue(internationalise,'CONF_PERM_EDIT_DESC')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
            
                 </StyledFlexStart>
                </Box>
                <BiztantuFooterButton
                    headerLabel = "CONF_PERM_EDIT_TITLE_CREATE" 
                    isiconRequired={false}
                    actionlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                    isBackbtnreq={true}
                    handleCustomBackbutton={handleCustomBackbutton}
                    redirecturl=""
                    handleActionButton={handleSave}
                    backButtonLabel= {handleValidateCodevalue(internationalise,"COMMON_BACK")}
                />
        </BiztantuLoader>
    )
}

export default CreateEditFunction;